<div class="flex flex-col gap-4" formGroupName="members">
  <tm-autocomplete-select-members [members]="managersList$ | async" [label]="'Select Manager'" [controlName]="'managers'"></tm-autocomplete-select-members>
  <tm-autocomplete-select-members [members]="membersList$ | async" [label]="'Select Members'" [controlName]="'members'"></tm-autocomplete-select-members>
</div>